import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { useIntl } from 'react-intl';
import { useAction } from 'hooks';
import Calendar from 'svg/calendar.svg';
import App from 'modules/App';
export const CalendarBtn = ({ popUpName, className, isDisabled })=>{
    const intl = useIntl();
    const dropdown = useSelector(App.selectors.dropdown);
    const openDropdown = useAction(App.actions.openDropdown, popUpName);
    const closeDropdown = useAction(App.actions.closeDropdown);
    const isOpen = dropdown === popUpName;
    const onClick = (evt)=>{
        evt.stopPropagation();
        if (isOpen) {
            closeDropdown();
        } else {
            openDropdown();
        }
    };
    return /*#__PURE__*/ _jsx("button", {
        className: cn('DateRangePickerInput_calendarIcon', className),
        type: "button",
        disabled: isDisabled,
        "aria-label": intl.formatMessage(App.messages.buttons.pickDateRange),
        onClick: onClick,
        children: /*#__PURE__*/ _jsx(Calendar, {
            className: cn('DateRangePickerInput_calendarIcon_svg', {
                'DateRangePickerInput_calendarIcon_svg--inactive': isDisabled
            }),
            focusable: "false"
        })
    });
};
